module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/blood_vessel-c3d439f0adab78d5dee3c0bb06cf0adb.png";